import type { UserType } from "app/types/userType";
import isPublicView from "app/utils/publicViewUtils";
import ENV from "config";
import cloneDeep from "lodash/cloneDeep";
import * as profileAPI from "../api/profileApi";
import store from "../store/store";
import { FetchModalEventDataHelper } from "./fetchModalEventDataHelper";
import { PublicViewHelper } from "./publicViewHelper";
import { SessionHelper } from "./sessionHelper";
export class UpdateOddsHelper {
  //
  static updateOdds: (e: any, callback: any) => void = (
    e: Record<string, any>,
    callback: (...args: Array<any>) => any
  ) => {
    const unsummarizedMarketsModalEventId: number = cloneDeep(
      store.getState().competitionListModel.unsummarizedMarketsModalEventId
    );
    const user: UserType = cloneDeep(store.getState().userModel.user);
    const data = {
      accountId: user["accountId"],
      userId: user["userId"],
      preferences: {
        oddsType: e,
      },
    };
    profileAPI
      .updateAccountDetails(data)
      .then(resp => {
        // used for public view only
        ENV.PUBLIC_VIEW === "TRUE" &&
          SessionHelper.setOddsType(resp.preferences["oddsType"]);
        store.dispatch.userModel.loadUser();
        // This method is responsible for fetching the prices for the runners in the bet slip when in public view.
        // This is because we cannot use loadUser() in public view as it will overwrite the new odds type stored locally
        isPublicView() && PublicViewHelper.fetchPricesForRunnersInBetslip();

        // After user odds type updated and modal open fetch fresh event data
        if (unsummarizedMarketsModalEventId !== -1) {
          FetchModalEventDataHelper.fetchEventData();
        } else if (callback) {
          callback();
        }
      })
      .catch(resp => {
        console.log("error updating odds", resp);
      });
  };
}
